// extracted by mini-css-extract-plugin
module.exports = {"UserImage":"UserImage_UserImage__3KyqN"};